<template>
  <WsCard001
    :to="to"
    :hasTopBar="hasTopBar"
    :class="{disable}"
    :bannerUrl="bannerUrl"
    class="lv-card"
    @click="$_onClick($event)"
  >
    <slot name="header">
      <div class="lv-card__icon-container">
        <i
          v-for="(icon, iconIndex) in headerIconList"
          :key="iconIndex"
          :class="icon.icon"
          class="icon"
          @click.stop="$emit(icon.event)"/>
      </div>
    </slot>
    <WsChips001 v-if="chips && chips.length" :value="chips" />
    <LvText
      h4
      bold
      class="ml-3"
    >
      {{ $t(title) }}
    </LvText>
    <WsChips001 v-if="tags && tags.length" :value="tags" />
    <WsSpec001
      v-if="spec && spec.length"
      :value="spec"
      :titleFontSize="specTitleFontSize"
      :textFontSize="specTextFontSize"
      @click-icon="$emit('click-icon', $event)"
    />
    <WsChips001 v-if="factoryTags && factoryTags.length" :value="factoryTags" />
    <LvFlexBox v-if="iconBtnList && iconBtnList.length" justifyContent="start">
      <IconButton
        v-for="(iconBtn, iconBtnIndex) in iconBtnList"
        :key="iconBtnIndex"
        :icon="iconBtn.icon"
        :color="iconBtn.color"
        :tooltipText="iconBtn.tooltipText"
        @click="$emit('click-icon-btn', iconBtn.id)"
      />
    </LvFlexBox>
    <template v-slot:footer>
      <div @click.stop>
        <slot name="footer"/>
      </div>
    </template>
  </WsCard001>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    chips: {
      type: Array,
    },
    tags: {
      type: Array,
    },
    spec: {
      type: Array,
    },
    btnText: {
      type: String,
    },
    to: {
      type: String,
    },
    hasTopBar: {
      type: Boolean,
      default: false,
    },
    factoryTags: {
      type: Array,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    headerIconList: {
      type: Array,
    },
    bannerUrl: {
      type: String,
      default: null,
    },
    specTitleFontSize: {
      type: String,
      default: 'h6',
    },
    specTextFontSize: {
      type: String,
      default: 'h6',
    },
    iconBtnList: {
      type: Array,
    },
  },
  methods: {
    $_onClick($event) {
      if (this.disable) return;
      this.$emit('click',$event);
    }
  },
};
</script>